var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCasaSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CP_Logo_Sport_Casino",
    "data-name": "CP_Logo Sport+Casino",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 72.013,
    viewBox: "0 0 180 72.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 180,
    height: 72.013
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M126.522,89.335h-4.159c-.032,0-.032,0,.1-.857.349-2.413.7-4.858,1.016-7.3.318-2.191.635-4.382.921-6.6.064-.445.1-.572.1-.572,2.889,0,3.524,0,5.112-.032a3.464,3.464,0,0,0,3.588-2.985c.445-2.127.762-4.286,1.111-6.414.286-1.937.508-3.842.762-5.779a7.053,7.053,0,0,0-.127-2.826,2.086,2.086,0,0,0-1.651-1.524,6.52,6.52,0,0,0-1.556-.191c-1.3-.032-3.207-.032-4.509,0a5.113,5.113,0,0,1,.064-.6c.286-1.905.54-3.651.794-5.557.032-.318.1-.7.1-.7a75.2,75.2,0,0,1,8.89.254,9.743,9.743,0,0,1,5.366,2.318,7.3,7.3,0,0,1,2.127,3.937,21.037,21.037,0,0,1-.1,7.462c-.349,2.318-.635,4.636-.984,6.954a17.055,17.055,0,0,1-3.048,8.128,10.594,10.594,0,0,1-5.842,3.747c-.7.191-1.429.318-2.159.445a.529.529,0,0,0-.508.54c-.349,2.572-.762,5.112-1.111,7.684-.064.413-.222.54-.635.54-1.207-.064-2.413-.064-3.651-.064",
    transform: "translate(-83.498 -32.341)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M77.607,80.671a21.644,21.644,0,0,1-6.065-.445,8.892,8.892,0,0,1-4.223-2.032,7.177,7.177,0,0,1-2.127-3.778,18.292,18.292,0,0,1-.064-6.573c.413-2.889.762-5.811,1.238-8.7a15.979,15.979,0,0,1,2.7-7.081,10.938,10.938,0,0,1,6.223-4.1,20.95,20.95,0,0,1,5.62-.667h5.207c-.286,1.937-.7,4.953-.953,6.858h-.445c-1.461,0-2.921-.032-4.382,0-2.191.032-3.556.984-3.969,3.175-.381,1.937-.667,3.937-.984,5.938-.254,1.683-.54,3.4-.73,5.08a20.621,20.621,0,0,0-.063,3.429c.1,1.238,1.111,2.032,2.6,2.1,1.524.063,3.62.063,5.176.063l-.1.6-.73,5.334a7.28,7.28,0,0,1-.127.762c-1.016.032-2.762.032-3.81.032",
    transform: "translate(-44.267 -32.281)",
    fill: "#fff200"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M121.713,85.939a6.557,6.557,0,1,1-6.6-6.541,6.545,6.545,0,0,1,6.6,6.541M111.2,89.177a5.037,5.037,0,0,0,5.938,1.461,5.256,5.256,0,0,0,2.953-3.4.773.773,0,0,0-.159-.476c-.1-.19-.286-.317-.318-.508-.159-.667-.286-1.3-.381-1.969a.9.9,0,0,1,.064-.508c.254-.381.063-.667-.159-.953a5.646,5.646,0,0,0-2.667-1.683,4.2,4.2,0,0,0-3.556.286,7.42,7.42,0,0,0-1.619,1.4,4.545,4.545,0,0,0-.762.984c-.6,1.175-.572,1.175.635,1.778.191.1.445.286.476.476.191.667.349,1.365.476,2.064a.871.871,0,0,1-.222.572c-.19.159-.445.286-.7.476",
    transform: "translate(-74.117 -54.187)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M122.82,87.753c.032-.381.1-.762.127-1.175a.488.488,0,0,1,.445-.508c.635-.127,1.27-.286,1.937-.381a.883.883,0,0,1,.667.254,11.587,11.587,0,0,1,1.111,1.365.548.548,0,0,1-.032.54,14.2,14.2,0,0,1-1.334,1.429.862.862,0,0,1-.635.127c-.635-.191-1.27-.445-1.905-.635s-.349-.635-.381-1.016",
    transform: "translate(-83.797 -58.478)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M127.787,107.652a1.927,1.927,0,0,1-.318-.222,4.641,4.641,0,0,1-.286-.413c-.73-1.016-.73-1.016.254-1.842.032-.032.064-.032.064-.064,1.3-1.111.762-.921,2.477-.508.984.254.889.254.635,1.27a1.627,1.627,0,0,1-1.524,1.429,8.012,8.012,0,0,0-1.3.349",
    transform: "translate(-86.446 -71.169)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M232.426,66.111h-7.843c-1.873,0-3.143-.476-3.874-1.461a4.9,4.9,0,0,1-.73-3.778l.286-2a7.135,7.135,0,0,1,1.873-4,5.623,5.623,0,0,1,4.255-1.619h7.843L235,47.6H227.79a18.882,18.882,0,0,0-5.08.7,11.831,11.831,0,0,0-3.937,2.032,9.645,9.645,0,0,0-2.54,3.207,13.592,13.592,0,0,0-1.27,4.255l-.54,3.905a8.456,8.456,0,0,0,.254,3.556,8.329,8.329,0,0,0,1.683,3.239,8.794,8.794,0,0,0,3.048,2.381,10.046,10.046,0,0,0,4.413.921H231.6Z",
    transform: "translate(-146.284 -32.486)",
    fill: "#ede93f"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M303.744,52.93a8.058,8.058,0,0,0-.73-2.7,5.4,5.4,0,0,0-1.715-1.969A5,5,0,0,0,298.5,47.5H286.28l-.762,5.652h11.3c.889,0,1.492.857,1.334,1.937a2.128,2.128,0,0,1-1.873,1.937h-8.827a4.047,4.047,0,0,0-2.477.794,7.636,7.636,0,0,0-1.842,1.937,11.3,11.3,0,0,0-1.238,2.477,14.24,14.24,0,0,0-.635,2.477,13.372,13.372,0,0,0-.063,1.778,8.373,8.373,0,0,0,.349,2.318,5.227,5.227,0,0,0,1.08,2.032,2.752,2.752,0,0,0,2.159.857h16.67l.064-.445h0l2.159-15.336a13.375,13.375,0,0,0,.064-2.985m-7.176,13.3h-8.446a1.279,1.279,0,0,1-1.207-.6,1.9,1.9,0,0,1-.254-1.4,2.268,2.268,0,0,1,.572-1.175,1.508,1.508,0,0,1,1.143-.54h8.732Z",
    transform: "translate(-191.914 -32.418)",
    fill: "#ede93f"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M453.376,52.93a8.059,8.059,0,0,0-.73-2.7,5.4,5.4,0,0,0-1.715-1.969,5,5,0,0,0-2.794-.762H434.864l-.826,5.684h12.383c.889,0,1.492.857,1.334,1.937a2.129,2.129,0,0,1-1.873,1.937h-8.827a4.048,4.048,0,0,0-2.477.794,7.639,7.639,0,0,0-1.842,1.937,11.293,11.293,0,0,0-1.238,2.477,14.228,14.228,0,0,0-.635,2.477,13.353,13.353,0,0,0-.064,1.778,8.371,8.371,0,0,0,.349,2.318,5.226,5.226,0,0,0,1.079,2.032,2.752,2.752,0,0,0,2.159.857h16.67l.063-.445h0l2.159-15.336a12.006,12.006,0,0,0,.1-3.016m-7.176,13.3h-8.446a1.279,1.279,0,0,1-1.207-.6,1.9,1.9,0,0,1-.254-1.4,2.267,2.267,0,0,1,.571-1.175,1.509,1.509,0,0,1,1.143-.54h8.732Z",
    transform: "translate(-294.014 -32.418)",
    fill: "#ede93f"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M377.2,58.491a3.749,3.749,0,0,0-1.937-1.334,10.49,10.49,0,0,0-3.048-.381h-6.763a.931.931,0,0,1-.508-.127,1.24,1.24,0,0,1-.54-.445,1.891,1.891,0,0,1-.254-1.334,2.151,2.151,0,0,1,.54-1.111,1.4,1.4,0,0,1,1.08-.508h11.875l.794-5.652h-9.875a22.071,22.071,0,0,0-3.778.286,7.423,7.423,0,0,0-2.953,1.08,5.767,5.767,0,0,0-1.937,2.223,11.7,11.7,0,0,0-1.08,3.747,12.913,12.913,0,0,0-.1,2.889,5.533,5.533,0,0,0,.7,2.286,3.982,3.982,0,0,0,1.651,1.492,5.554,5.554,0,0,0,2.318.508H371.3c.921,0,1.524.889,1.365,2a2.2,2.2,0,0,1-1.937,2H357.294l-.794,5.684h15.3A4.516,4.516,0,0,0,374.5,71a6.772,6.772,0,0,0,1.81-1.873,9.554,9.554,0,0,0,1.079-2.223,10.523,10.523,0,0,0,.476-1.842,16.245,16.245,0,0,0,.159-4,4.5,4.5,0,0,0-.826-2.572",
    transform: "translate(-243.305 -32.486)",
    fill: "#ede93f"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M209.827,151.628H207.7l1.588-11.3a1.375,1.375,0,0,1,.286-.762c.159-.191.286-.318.413-.445a1.575,1.575,0,0,1,.635-.254,4.336,4.336,0,0,1,.6-.063h3.4a3.857,3.857,0,0,1,.572.032,6.575,6.575,0,0,1,.7.127,3.884,3.884,0,0,1,.762.318,1.89,1.89,0,0,1,.667.572,2.331,2.331,0,0,1,.445.826,4.647,4.647,0,0,1,.191,1.873q-.048.476-.1.857c-.032.318-.1.635-.159.984-.064.318-.127.667-.222.984a4.686,4.686,0,0,1-.381.921,3.5,3.5,0,0,1-.54.794,3.255,3.255,0,0,1-.889.762,4.123,4.123,0,0,1-.953.413,3.326,3.326,0,0,1-.953.159,7.463,7.463,0,0,1-.826.032h-2.7Zm3.08-4.763a2.152,2.152,0,0,0,1.27-.318,2.73,2.73,0,0,0,.7-.6,2.523,2.523,0,0,0,.381-.73,7.6,7.6,0,0,0,.349-1.588,10.772,10.772,0,0,0,.127-1.429,1.723,1.723,0,0,0-.667-1.429,1.809,1.809,0,0,0-1.143-.318h-2.1a.286.286,0,0,0-.159.032c-.064.032-.1.063-.159.1a.433.433,0,0,0-.191.318l-.826,5.938h2.413Z",
    transform: "translate(-141.752 -94.729)",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M254.888,138.9a3.019,3.019,0,0,1,1.111.19,1.852,1.852,0,0,1,.794.54,1.764,1.764,0,0,1,.381.889,3.428,3.428,0,0,1,0,1.4l-.7,5.017a3.657,3.657,0,0,1-.159.635,1.382,1.382,0,0,1-.413.635,1.307,1.307,0,0,1-.667.317,5.669,5.669,0,0,1-.73.064h-4.636c-.254,0-.54-.032-.857-.064a1.465,1.465,0,0,1-.826-.413,1.953,1.953,0,0,1-.381-.6,2.493,2.493,0,0,1-.159-.7,2.569,2.569,0,0,1,0-.7c.032-.222.032-.444.063-.635a6.2,6.2,0,0,1,.318-1.27,2.757,2.757,0,0,1,.826-1.111,2.159,2.159,0,0,1,.984-.476,4.415,4.415,0,0,1,.857-.1h4.191l.1-.667a2.1,2.1,0,0,0,.032-.445.758.758,0,0,0-.159-.444.909.909,0,0,0-.444-.349,1.573,1.573,0,0,0-.54-.064h-4.763l.222-1.651Zm-3.747,5.3a1.709,1.709,0,0,0-.349.032.957.957,0,0,0-.476.286,2.16,2.16,0,0,1-.191.286,1.739,1.739,0,0,0-.191.762,2.738,2.738,0,0,0-.032.54.984.984,0,0,0,.159.54,1.108,1.108,0,0,0,.286.191.846.846,0,0,0,.381.1h3.207a.361.361,0,0,0,.254-.1.424.424,0,0,0,.159-.191,2.022,2.022,0,0,0,.064-.222l.318-2.223h-3.588Z",
    transform: "translate(-169 -94.797)",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M286.357,142.483a6.624,6.624,0,0,1,.413-1.556,2.944,2.944,0,0,1,.984-1.27,4.046,4.046,0,0,1,.794-.476,4.109,4.109,0,0,1,.826-.254,3.335,3.335,0,0,1,.762-.1c.254,0,.445-.032.635-.032H292.2l-.222,1.651h-.889a5.366,5.366,0,0,0-.953.1,1.869,1.869,0,0,0-.984.572,1.991,1.991,0,0,0-.508.857,8.457,8.457,0,0,0-.254,1.048l-.762,5.461H285.5Z",
    transform: "translate(-194.849 -94.729)",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M312.488,130.815l.254-1.715h2.127l-.254,1.715Zm-.222,1.4h2.127l-1.365,9.684H310.9Z",
    transform: "translate(-212.184 -88.109)",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M338.31,147.5a1.281,1.281,0,0,1-.54.7,1.63,1.63,0,0,1-.762.317,7.255,7.255,0,0,1-.794.064h-3.429a5.924,5.924,0,0,1-1.429-.159,2.17,2.17,0,0,1-1.016-.572,2.128,2.128,0,0,1-.635-1.238,5.607,5.607,0,0,1,.032-1.619l.857-6.1h2.127l-.794,5.715a4.184,4.184,0,0,0-.063,1.048,2.05,2.05,0,0,0,.191.667,1.1,1.1,0,0,0,.635.508,4.5,4.5,0,0,0,.984.1h1.778a.893.893,0,0,0,.635-.191.384.384,0,0,0,.19-.286c.032-.1.032-.191.064-.286l1.016-7.271h2.127l-1.111,7.938a.843.843,0,0,1-.063.667",
    transform: "translate(-224.988 -94.797)",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M368.357,142.483a6.618,6.618,0,0,1,.413-1.556,2.944,2.944,0,0,1,.984-1.27,4.046,4.046,0,0,1,.794-.476,4.1,4.1,0,0,1,.826-.254,3.335,3.335,0,0,1,.762-.1c.254,0,.445-.032.635-.032H374.2l-.222,1.651h-.889a5.365,5.365,0,0,0-.953.1,1.869,1.869,0,0,0-.984.572,1.988,1.988,0,0,0-.508.857,8.44,8.44,0,0,0-.254,1.048l-.762,5.461H367.5Z",
    transform: "translate(-250.813 -94.729)",
    fill: "#fff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M394.456,130.815l.254-1.715h2.127l-.254,1.715Zm-.191,1.4h2.127l-1.365,9.684H392.9Z",
    transform: "translate(-268.148 -88.109)",
    fill: "#fff"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M412.21,129.1h2.127l-1.778,12.8H410.4Z",
    transform: "translate(-280.091 -88.109)",
    fill: "#fff"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M435.907,138.6a5.558,5.558,0,0,1,1.016.127,3.568,3.568,0,0,1,.984.318,2.4,2.4,0,0,1,1.365,1.492,4.123,4.123,0,0,1,.222,1.048c.032.349.032.7.032,1.048-.032.349-.064.635-.1.889a8.533,8.533,0,0,1-.7,2.508,4.989,4.989,0,0,1-1.08,1.461,2.931,2.931,0,0,1-.953.572,6.929,6.929,0,0,1-1.079.318c-.381.063-.73.1-1.08.127s-.667.032-.921.032c-.286,0-.6,0-.952-.032s-.667-.064-1.016-.127a3.569,3.569,0,0,1-.984-.318,2.416,2.416,0,0,1-.826-.572,2.5,2.5,0,0,1-.572-.921,4.123,4.123,0,0,1-.222-1.048,5.772,5.772,0,0,1,0-1.048q.048-.524.1-.857c.032-.254.1-.572.159-.921a8.1,8.1,0,0,1,.318-1.08,7.907,7.907,0,0,1,.508-1.048,4.358,4.358,0,0,1,.794-.921,3.456,3.456,0,0,1,.984-.572,6.062,6.062,0,0,1,1.08-.318c.349-.063.73-.1,1.048-.127.349,0,.667-.032.952-.032h.921m-4.667,6.223a2.02,2.02,0,0,0,.381,1.207,1.7,1.7,0,0,0,1.016.667,5.2,5.2,0,0,0,1.207.127,5.473,5.473,0,0,0,1.238-.127,2.455,2.455,0,0,0,1.175-.667,2.6,2.6,0,0,0,.73-1.175,9.419,9.419,0,0,0,.254-1.3l.1-.572a4.673,4.673,0,0,0,.032-.667,2.835,2.835,0,0,0-.1-.7,1.771,1.771,0,0,0-.286-.6,1.5,1.5,0,0,0-.476-.413,1.618,1.618,0,0,0-.54-.222,1.849,1.849,0,0,0-.6-.1c-.19,0-.413-.032-.6-.032a3.855,3.855,0,0,0-.572.032,2.047,2.047,0,0,0-.635.1,5.044,5.044,0,0,0-.635.222,1.886,1.886,0,0,0-.572.413,2.97,2.97,0,0,0-.444.6,3.237,3.237,0,0,0-.286.7,5.532,5.532,0,0,0-.159.7q-.048.333-.1.572a5.118,5.118,0,0,0-.127,1.238",
    transform: "translate(-292.803 -94.592)",
    fill: "#fff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M470.457,142.483a6.624,6.624,0,0,1,.413-1.556,2.944,2.944,0,0,1,.984-1.27,4.048,4.048,0,0,1,.794-.476,4.109,4.109,0,0,1,.826-.254,3.335,3.335,0,0,1,.762-.1c.254,0,.445-.032.635-.032H476.3l-.222,1.651h-.889a5.365,5.365,0,0,0-.952.1,1.869,1.869,0,0,0-.984.572,1.99,1.99,0,0,0-.508.857,8.479,8.479,0,0,0-.254,1.048l-.762,5.461H469.6Z",
    transform: "translate(-320.494 -94.729)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCasaSimple);
export default __webpack_public_path__ + "static/media/logo_casa_simple.02b84fe563a418beb8071350da281806.svg";
export { ForwardRef as ReactComponent };